/* eslint-disable react/prefer-stateless-function */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { makeSelectAppError } from './selectors';

class InlineAppErrorText extends React.Component {
  // eslint-disable-line react/prefer-stateless-function

  render() {
    if (this.props.error === '') {
      return null;
    }

    return (<div className="inline-error" dangerouslySetInnerHTML={{ __html: this.props.error }} />);
  }
}

InlineAppErrorText.propTypes = {
  error: PropTypes.string,
};

const mapStateToProps = createStructuredSelector({
  error: makeSelectAppError(),
});

const withConnect = connect(mapStateToProps);

export default compose(withConnect)(InlineAppErrorText);



// WEBPACK FOOTER //
// ./app/containers/AppError/index.js